// @flow
import * as React from 'react';

import clsx from 'clsx';

import { Base } from '@gandi/ui';
import { useTranslator } from '@gandi/translate';

import {
  InputTextField,
  TextAreaField,
  CheckBoxGroupField,
} from 'gandi.react-form';

import DomainNameField from './DomainNameField';
import Row from './Row';
import styles from './DomainFields.scss';

type Props = {| category: string, topic?: string |};

function DomainFields({ category, topic }: Props): React.Element<typeof Base> {
  const { __ } = useTranslator();
  const showDomainName = category === 'domain' || topic === 'spam';
  const itemsContactOwner = [
    {
      name: 'params.whois_contact.contact_owner',
      label: __('Owner'),
      value: 'contact_owner',
    },
    {
      name: 'params.whois_contact.contact_administration',
      label: __('Administrative'),
      value: 'contact_administration',
    },
    {
      name: 'params.whois_contact.contact_tech',
      label: __('Technical'),
      value: 'contact_tech',
    },
    {
      name: 'params.whois_contact.contact_billing',
      label: __('Billing'),
      value: 'contact_billing',
    },
  ];
  const itemsInvolvedFields = [
    {
      name: 'params.involved_fields.errors_name',
      label: __('First name / Last name'),
      value: 'errors_name',
    },
    {
      name: 'params.involved_fields.errors_company',
      label: __('Company/Association'),
      value: 'errors_company',
    },
    {
      name: 'params.involved_fields.errors_postal',
      label: __('Postal Address'),
      value: 'errors_postal',
    },
    {
      name: 'params.involved_fields.errors_email',
      label: __('Email address'),
      value: 'errors_email',
    },
    {
      name: 'params.involved_fields.errors_tel',
      value: 'errors_tel',
      label: __('Phone'),
    },
  ];

  return (
    <Base backgroundColor="grey-lighter" padding="small" separatorBottom>
      {showDomainName && <DomainNameField category={category} topic={topic} />}

      {topic === 'whois' && (
        <Row>
          <Base className="for-2-columns">
            {/* $FlowFixMe[prop-missing] custom, input, meta */}
            <CheckBoxGroupField
              options={itemsContactOwner}
              label={__('Contacts in question')}
              name="params.whois_contact"
              className={styles.checkBox}
              required
            />
          </Base>
          <Base className={clsx('for-2-columns', styles.checkBoxGroup)}>
            {/* $FlowFixMe[prop-missing] custom, input, meta */}
            <CheckBoxGroupField
              options={itemsInvolvedFields}
              label={__('Erroneous elements')}
              name="params.involved_fields"
              className={styles.checkBox}
              required
            />
          </Base>
        </Row>
      )}

      {topic === 'spam' && (
        <>
          <Row fullRow>
            <TextAreaField
              name="params.mail_headers"
              placeholder={__(
                'Indicate here the headers of the concerned emails.'
              )}
              label={__('Email headers')}
              required
            />
          </Row>
          <Row fullRow>
            <TextAreaField
              name="params.mail_body"
              label={__('Email body')}
              placeholder={__(
                'Indicate here the content of the concerned email'
              )}
            />
          </Row>
        </>
      )}

      {topic === 'phishing' && (
        <Row fullRow>
          <InputTextField
            type="url"
            name="params.url"
            label={__('URL of the illegal content')}
            required
          />
        </Row>
      )}
    </Base>
  );
}

export default DomainFields;
